module.exports = __webpack_public_path__ + "img/Southwest Quinoa Bowl-Tofu.423647e3.jpg";